import { assign } from 'xstate';
import {
  AddPaymentProfileEvent,
  ChangePaymentProfileEvent,
  Context,
  DeletePaymentProfileEvent,
} from './types';
import { PaymentProfileStatus } from '../../models';

export const setActivePaymentProfile = assign<Context>(
  (context, event: ChangePaymentProfileEvent) => ({
    paymentProfiles: context.paymentProfiles.map((profile) => {
      if (profile.status === PaymentProfileStatus.ACTIVE) {
        return { ...profile, status: PaymentProfileStatus.NORMAL };
      }
      if (profile.id === event.paymentProfileId) {
        return { ...profile, status: PaymentProfileStatus.ACTIVE };
      }
      return profile;
    }),
  })
);
export const addPaymentProfile = assign<Context>(
  (context, event: AddPaymentProfileEvent) => ({
    paymentProfiles: [
      ...context.paymentProfiles,
      { ...event.paymentProfile, status: PaymentProfileStatus.NORMAL },
    ],
  })
);
export const deletePaymentProfile = assign<Context>(
  (context, event: DeletePaymentProfileEvent) => ({
    paymentProfiles: context.paymentProfiles.filter(
      (profile) => profile.id !== event.paymentProfileId
    ),
  })
);
